<script>
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import * as globalEnum from "src/common/global-enum";
import * as utils from "src/store/utils";
import {
  parseImgUrl,
  setImgStyle,
  parseImgUrlProductImg,
} from "src/filter/modules/img";
@Component({
  name: "finish-cost-picture",
  components: {},
})
export default class App extends Vue {
  @Prop({ type: Object, default: () => ({}) }) info;

  imgInfo = {
    class: null,
    url: null,
  };
  titleList = [];
  // data = {
  // quotedList:[],
  // costList: [],
  // diffdList: [],
  // };
  productCategory = ''
  mounted() {
    this.imgInfo = setImgStyle(this.info.imgUrl);
    this.productCategory = this.info.productCategory;
    // 可用category判断模板，重新组装数据，批量渲染
    if (this.productCategory == '毛织') {
      this.titleList = [
        "纱线成本",
        "织机+缝盘",
        "后整",
        "其他",
        "物料",
        "总价",
      ];
    } else if(this.productCategory == '牛仔') {
      this.titleList = ["面料", "辅料", "加工费", "洗水", "其他", "总价"];
    } else {
      this.titleList = ["面料", "辅料", "加工费", "工艺", "其他", "总价"];
    }
  }
  render(h) {
    return (
      <div class="finish-goods-cost-picture">
        <div class="imgContainer">
          <div class="img">
            <img src={this.imgInfo.url} class={this.imgInfo.class} />
          </div>
          <div class="period">
            <span>{this.info.materialCode}</span>
            <span>{this.info.tagPrice}</span>
            <span>{this.info.orderNum}</span>
          </div>
        </div>
        <div class="quote-container">
          <div class="quote">
            <div class="quote1">
              <div class="materialCode">
                <div>{this.info.vendorName}</div>
                <div></div>
              </div>
              <div>
                <p>报价</p>
                <div></div>
              </div>
              <div>
                <p>目标价</p>
                <div></div>
              </div>
              <div>
                <p>议价</p>
                <div></div>
              </div>
              <div>
                <p>采购价</p>
                <div></div>
              </div>
            </div>
            <div class="quote1">
              <div class="materialCode">{this.info.productCategory}</div>
              <div>{this.info.quotedPrice}</div>
              <div>{this.info.standardCost}</div>
              <div>{this.info.bargainVendorPrice}</div>
              <div>{this.info.contractCost}</div>
            </div>
            <div class="quote2">
              <div class="materialCode">{this.info.s076}</div>
              <div>{this.info.rate1}</div>
              <div>{this.info.rate2}</div>
              <div>{this.info.rate3}</div>
              <div>{this.info.rate4}</div>
            </div>
          </div>
          <div class="fill">{ this.info.prodModel != '3' ?  ''  : this.info.unFobSum}</div>
        </div>
        <div class="quote-container">
          <div class="quote">
            <div class="middle-quote">
              <div class="materialCode">
                <p>{this.info.masterCode}</p>
                <p>{this.info.masterVendor}</p>
              </div>
              <div>
                <p>{this.info.masterDesc}</p>              
                <p>{this.info.masterComponent}</p>              
              </div>
            </div>
            <div class="quote1">
              <div class="materialCode"></div>
              {this.titleList
                .filter((item, index) => index <= 3)
                .map((item, index) => {
                  return <div>{item}</div>;
                })}
            </div>
            {/** quotedLoomAndSewingDisc 供应商报价*/}
            <div class="quote1">
              <div class="materialCode">{this.info.vendorName}</div>
              <div>
                {this.productCategory == '毛织'
                  ? this.info.quotedYarnCost || ''
                  : this.info.quotedMaterial || ''}
              </div>
              <div>
                {this.productCategory == '毛织'
                  ? this.info.quotedLoomAndSewingDisc || ''
                  : this.info.quotedAccessories || ''}
              </div>
              <div>
                {this.productCategory == '毛织'
                  ? this.info.quotedIntegral || ''
                  : this.info.quotedProcessCost || ''}
              </div>
              <div>
                {this.productCategory == '毛织'
                  ? this.info.quotedOther || ''
                  : this.productCategory == '牛仔' 
                  ? this.info.quotedWashingWater || ''
                  : this.info.quotedSpecialProcess || ''}
              </div>
              
            </div>
            {/** quotedLoomAndSewingDisc 成控核价*/}
            <div class="quote1">
              <div class="materialCode">核价（裸价）</div>
              <div>
                {this.productCategory == '毛织'
                  ? this.info.costYarnCost || ''
                  : this.info.costMaterial || ''} 
              </div>
              <div>
                {this.productCategory == '毛织'
                  ? this.info.costLoomAndSewingDisc || ''
                  : this.info.costAccessories || ''}
              </div>
              <div>
                {this.productCategory == '毛织'
                  ? this.info.costIntegral || ''
                  : this.info.costProcessCost || ''}
              </div>
              <div>
                {this.productCategory == '毛织'
                  ? this.info.costOther || ''
                  : this.productCategory == '牛仔' 
                  ? this.info.costWashingWater || ''
                  : this.info.costSpecialProcess || ''}
              </div>
            </div>
          </div>
          <div class="fill">
            <div class="middle-quote">
              <div>
                <p>{this.info.costYarnOrUnitPrice}</p>
                <p>{this.info.costWeightOrUsage}</p>
              </div>
            </div>
            <div class="quote1">
              {this.titleList
                .filter((item, index) => index > 3)
                .map((item, index) => {
                  return <div>{item}</div>;
                })}
            </div>
            <div class="quote1">
              <div>
                {this.productCategory == '毛织'
                  ? this.info.quotedMater || ''
                  : this.info.quotedOther || ''}
              </div>
              <div>
                {this.info.quotedTotal}
              </div>
            </div>
            <div class="quote1">
              <div>
                {this.productCategory == '毛织'
                  ? this.info.costMater || ''
                  : this.info.costOther || ''}
              </div>
              <div>
                {this.info.costTotal}
              </div>
            </div>
          </div>
        </div>
        <div class="remark">
          {this.info.prescriptiveMaterial}
        </div>
      </div>
    );
  }
}
</script>

<style lang="scss" scope>
.finish-goods-cost-picture {
  border: 1px solid #333;
  width: 480px;
  height: 475px;
  overflow: hidden;
  font-size: 12px;
  .imgContainer {
    & .period {
      display: flex;
      justify-content: space-between;
      height: 20px;
    }
    & .img {
      width: 230px;
      height: 160px;
      margin: 0 auto;
      text-align: center;
      img {
        width: auto !important;
        height: 90% !important;
      }
    }
  }
  & > .quote-container {
    display: flex;
    border-top: 1px solid #333;
    .quote {
      flex: 1;
      .materialCode {
        width: 100px !important;
      }
      .middle-quote {
        display: flex;
        height: 35px;
        border-bottom: 1px solid;
        & > div {
          flex: 1;
          overflow: hidden;
        }
      }
      .quote1 {
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #333;
        & > div {
          width: 50px;
          height: 100%;
          border-right: 1px solid #333;
          overflow: hidden;
          display: table;
          table-layout: fixed;
          word-wrap: break-word;
        }
      }
      .quote2 {
        height: 35px;
        display: flex;
        align-items: center;
        align-content: space-between;
        justify-content: space-between;
        & > div {
          width: 50px;
          height: 100%;
          border-right: 1px solid #333;
          overflow: hidden;
          display: table;
          table-layout: fixed;
          word-wrap: break-word;
        }
      }
    }
    .fill {
      width: 150px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: center;
      .middle-quote {
        display: flex;
        height: 35px;
        border-bottom: 1px solid;
        & > div {
          flex: 1;
        }
      }
      .quote1 {
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #333;
        & > div {
          width: 100px;
          height: 100%;
          border-right: 1px solid #333;
          overflow: hidden;
        }
        & > div:nth-child(2) {
          border-right: none;
        }
      }
    }
  }
  & > .remark {
    height: 50px;
    display: flex;
    .title {
      width: 100px;
      border-right: 1px solid #333;
    }
    .content {
      height: 50px;
      flex: 1;
    }
  }
}
</style>